<template>
    <BrandTileCmp :size="size" :image="image" :icon="tile.icon" :text="tile.text"
        :background="tile.background" :color="tile.color" />
</template>

<script>
import BrandTileCmp from '@/utils/components/BrandTileCmp.vue'
import { getAuditActorTile } from '@/audit/models/AuditActor'

// Só o quadrado do ator (sem nome): usado na coluna e nas opções do filtro.
export default {
    name: 'AuditActorTileCmp',
    components: {
        BrandTileCmp,
    },
    props: {
        kind: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            default: 20,
        },
    },
    computed: {
        tile() {
            return getAuditActorTile(this.kind)
        },
        image() {
            return this.tile.mark ? require(`@/channel/images/marks/${this.tile.mark}`) : null
        },
    },
}
</script>
